import { observer } from 'mobx-react-lite'
import { PresetDropdownItem, PresetDropdownList } from 'shared/Preset'
import { toastStore } from 'shared/ui'
import {
  type Chatbot,
  type ChatbotInstructionType,
  type IChatbotInstructionTemplate,
} from 'entities/Chatbot'

import { type IChatbotTemplate } from 'pages/chatbot/config'
import { chatbotOperation } from 'pages/chatbot/store/chatbotOperationStore'

type IAgentTypeListProps = {
  activeTemplates: IChatbotTemplate[]
  model: Chatbot
  id: number | null
  instructions: Map<ChatbotInstructionType, IChatbotInstructionTemplate>
  closeMenu: () => void
}

export const AgentTypeList = observer(
  ({ activeTemplates, model, id, instructions, closeMenu }: IAgentTypeListProps) => {
    return (
      <PresetDropdownList title='AI Agent type'>
        {activeTemplates.map((template) => (
          <PresetDropdownItem
            key={template.name}
            selected={model.type === template.type}
            onClick={() => {
              if (model.type === template.type) return closeMenu()

              chatbotOperation
                .changeInstruction(
                  model,
                  { agentId: id, type: template.type },
                  instructions.get(template.type)
                )
                .then((isChanged) => {
                  if (isChanged) {
                    toastStore.add({
                      title: 'Agent type changed',
                      type: 'info',
                    })
                  }
                  closeMenu()
                })
            }}
            icon={template.icon}
            name={template.name}
            description={template.description}
            isNew={template.isNew}
            isDisabled={template.isDisabled}
          />
        ))}
      </PresetDropdownList>
    )
  }
)
